module.exports = __webpack_public_path__ + "static/media/wsp_logo.cb52d506.png";